import React from "react"
import { VStack, Image } from "@chakra-ui/react"
import Logo from "../images/horizontal-light.svg"

export default function GradientBox({ children }) {
  return (
    <VStack
      h="100%"
      p="10% 20% 10% 20%"
      justifyContent="flex-start"
      bgGradient="linear(to-b, #3f268f, #860ebf)"
      alignItems="flex-start"
      gap={16}
    >
      <Image width="60%" src={Logo} alt="Blind Insight Logo" />
      {children}
    </VStack>
  )
}
